import { useState, useEffect } from 'react'

/**
 * Custom hook to manage a resizing state for disabling transitions during window resize.
 * @param {number} debounceTime - Time in milliseconds to debounce the resize event.
 * @returns {boolean} isResizing - Whether the window is currently being resized.
 */
export function useIsResizing(debounceTime = 200) {
	const [isResizing, setIsResizing] = useState(false)

	useEffect(() => {
		let resizeTimeout: any

		const handleResize = () => {
			setIsResizing(true)
			clearTimeout(resizeTimeout)
			resizeTimeout = setTimeout(() => {
				setIsResizing(false) // Stop resizing after debounce
			}, debounceTime)
		}

		window.addEventListener('resize', handleResize)
		return () => {
			window.removeEventListener('resize', handleResize)
			clearTimeout(resizeTimeout)
		}
	}, [debounceTime])

	return isResizing
}
